import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, formatApiErrorDetail } from "../lib/api";
import { FalkeTekLogo, FalkeCoinLogo } from "../components/Brand";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function MagicVerify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-link/verify", { token });
        const user = await loginWithToken(data);
        setStatus("success");
        setTimeout(() => {
          if (user.role === "admin" || user.role === "buchhalter") navigate("/admin");
          else if (user.role === "vertriebler") navigate("/vertriebler");
          else if (user.tippgeber_modus === "gewerblich_aktiv") navigate("/app/tippgeber");
          else navigate("/app");
        }, 700);
      } catch (err) {
        setError(formatApiErrorDetail(err.response?.data?.detail) || "Login fehlgeschlagen.");
        setStatus("error");
      }
    })();
  }, [token, loginWithToken, navigate]);

  return (
    <div className="min-h-screen bg-falke-warmwhite flex flex-col" data-testid="magic-verify-page">
      <header className="px-6 py-5 bg-white border-b border-falke-blue/10">
        <FalkeTekLogo />
      </header>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="falke-card p-10 max-w-md w-full text-center">
          <div className="mx-auto mb-5 opacity-60"><FalkeCoinLogo size={64} /></div>
          {status === "verifying" && (
            <>
              <Loader2 className="mx-auto text-falke-orange animate-spin mb-3" size={42} />
              <h2 className="font-heading text-xl text-falke-blue mb-1">Login wird geprüft …</h2>
              <p className="text-sm text-falke-anthracite/70">Einen Moment bitte.</p>
            </>
          )}
          {status === "success" && (
            <>
              <CheckCircle2 className="mx-auto text-emerald-500 mb-3" size={42} />
              <h2 className="font-heading text-xl text-falke-blue mb-1">Willkommen zurück!</h2>
              <p className="text-sm text-falke-anthracite/70">Du wirst gleich weitergeleitet …</p>
            </>
          )}
          {status === "error" && (
            <>
              <XCircle className="mx-auto text-rose-500 mb-3" size={42} />
              <h2 className="font-heading text-xl text-falke-blue mb-1">Login fehlgeschlagen</h2>
              <p className="text-sm text-falke-anthracite/70 mb-5" data-testid="magic-verify-error">{error}</p>
              <Link to="/login" className="btn-primary inline-block">Erneut versuchen</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
